var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 40.4645V0H21.5V40.4645L33.1421 28.8223C34.1184 27.846 35.7013 27.846 36.6777 28.8223C37.654 29.7986 37.654 31.3816 36.6777 32.3579L20.7678 48.2678C19.7914 49.2441 18.2085 49.2441 17.2322 48.2678L1.32232 32.3579C0.34601 31.3816 0.34601 29.7986 1.32232 28.8223C2.29863 27.846 3.88154 27.846 4.85785 28.8223L16.5 40.4645Z",
    fill: "#B1B1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrow);
export default __webpack_public_path__ + "static/media/scroll_arrow.3f4f392f8e87cd29691b82bf262dcbfa.svg";
export { ForwardRef as ReactComponent };